import { Injectable } from "@angular/core";
import { CanActivate, Router, RouterStateSnapshot, ActivatedRouteSnapshot } from "@angular/router";
import { AuthenticationService } from "./auth.service";
import swal from "sweetalert2";

@Injectable()
export class AuthGuardAdminService implements CanActivate {

    constructor(public auth: AuthenticationService, public router: Router) {}
    
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (this.auth.isAuthenticated()) {
            const path = route.routeConfig && route.routeConfig.path;

            if (path == "login-history") {
                if (this.auth.hasRole("UserAccessHistoryViewer")) {
                    return true
                }
            } else if (this.auth.hasRole("admin") || this.hasAccessToThisPath(path)) {
                return true
            }

            swal.fire("Acesso negado", "Este usuário não tem permissão para acessar este conteúdo.", "info")
                .then(() => this.router.navigate(['']))
            return false
        } else {
            this.router.navigate(['login'], {
                queryParams: {
                    return: state.url
                }
            });
            return false;
        }
    }

    private hasAccessToThisPath(path): boolean {
        if(path == "users" && this.auth.hasRole("view-users")) {
            return true
        } else if(path == "login-history" && this.auth.hasRole("UserAccessHistoryViewer")) {
            return true
        } else {
            return false
        }
    }
}